import React from 'react'
import { IconCheckDefault } from '@mc/design-system'

export const ValueProps = ({
  items,
}: {
  items: (string | React.ReactElement)[]
}) => (
  <div className='col-12'>
    <div className='d-flex flex-column align-items-center align-self-stretch justify-content-center mc-px-4 mc-pb-8'>
      <ul className='d-flex flex-gap-2 flex-column align-items-start'>
        {items?.map((item, index) => (
          <li key={index} aria-labelledby={`item-label-${index}`}>
            <IconCheckDefault size={2} aria-hidden='true' />
            <span
              id={`item-label-${index}`}
              className='mc-pl-2 d-none d-md-inline'
            >
              {item}
            </span>
            <span
              className='mc-pl-2 d-inline d-md-none mc-text-small'
              aria-hidden='true'
            >
              {item}
            </span>
          </li>
        ))}
      </ul>
    </div>
  </div>
)
